import React from 'react';
import { ImBlocked } from 'react-icons/im';
import BodyStep from '../../components/BodyStep';
import { Content } from '../../components/BodyStep/styles';

import { Container } from './styles';

const Unauthorized: React.FC = () => {
  return (
    <BodyStep>
      <Content>
        <Container>
          <h1>
            <ImBlocked />
            Acesso bloqueado
          </h1>
          <h4>Você não possui permissão para utilizar esse recurso</h4>
        </Container>
      </Content>
    </BodyStep>
  );
};

export default Unauthorized;
